export const INDUSTRIE = "INDUSTRIE";
export const KOMMUNAL = "KOMMUNAL";
export const KANAL_KOMMUNAL = "KANAL_KOMMUNAL";
export const KANAL_INDUSTRIE = "KANAL_INDUSTRIE";
export const PRIVAT = "PRIVAT";
export const AUSSERHALB_RLP = "AUSSERHALB_RLP";

export function betriebstypIdToObj(id) {
    switch (id) {
        case INDUSTRIE:
            return {id: INDUSTRIE, value: "industrie"};
        case KOMMUNAL:
            return {id: KOMMUNAL, value: "kommunal"};
        case KANAL_KOMMUNAL:
            return {id: KANAL_KOMMUNAL, value: "kanal kommunal"};
        case KANAL_INDUSTRIE:
            return {id: KANAL_INDUSTRIE, value: "kanal industrie"};
        case PRIVAT:
            return {id: PRIVAT, value: "kommunal < 50 EW"};
        case AUSSERHALB_RLP:
            return {id: AUSSERHALB_RLP, value: "außerhalb RLP"};
        default:
            return null;
    }
}
